import React from 'react';
import { getLabelForSplitShare, SplitSalesShare } from '../../../Enums/SplitSalesShare';
import CustomRadioButton from '../../../Elements/ids/InputElements/RadioButton';

const SplitSalesShareSelector = ({ editedSplitData, setEditedSplitData }) => {
  return (
    <div className="splitSales-radioButton-container">
      <CustomRadioButton
        checked={editedSplitData.share === SplitSalesShare.FiftyFifty}
        label={getLabelForSplitShare(SplitSalesShare.FiftyFifty)}
        onChange={() => {
          setEditedSplitData({ ...editedSplitData, share: SplitSalesShare.FiftyFifty });
        }}
      />
      <CustomRadioButton
        checked={editedSplitData.share === SplitSalesShare.EightyTwenty}
        label={getLabelForSplitShare(SplitSalesShare.EightyTwenty)}
        onChange={() => {
          setEditedSplitData({ ...editedSplitData, share: SplitSalesShare.EightyTwenty });
        }}
      />
    </div>
  );
};

export default SplitSalesShareSelector;
